module.exports = __webpack_public_path__ + "img/ic-contact-mail.f5a5950c.svg";